import { defineAsyncComponent, h } from "vue";
import store from "@/stores";

const versioned = (v1, v2) => {
  const oldDesign = defineAsyncComponent(v1);
  const newDesign = defineAsyncComponent(v2);
  return {
    name: "VersionedRoute",
    computed: {
      isPortalV2() {
        return store.getters["organization/isPortalV2"];
      },
    },
    render() {
      return h(this.isPortalV2 ? newDesign : oldDesign);
    },
  };
};

export default [
  {
    path: "/users/:userId/prescriptions/:businessPrescriptionId",
    component: versioned(
      () => import("@/views/user/PrescriptionView.vue"),
      () => import("@/views/v2/PrescriptionView.vue"),
    ),
    meta: {
      hideNav: true,
      preventInit: true,
      authentication: { required: true },
    },
  },
];
